import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { Entity } from '../types/entity';
import queryClient from '../query-client';

export type UpdateEntityFields = Partial<
    Pick<Entity, 'name' | 'legalName' | 'type' | 'financialYearEndDay' | 'financialYearEndMonth' | 'isArchived'> & { groups: string[] }
>;

export type UpdateEntitiesRequest = {
    id: string;
    fields: UpdateEntityFields;
}[];

async function updateEntities(request: UpdateEntitiesRequest): Promise<void> {
    const { data } = await api.patch(`/entities`, request);
    return data;
}

export function useUpdateEntities(): UseMutationResult<void, AxiosError, UpdateEntitiesRequest, unknown> {
    return useMutation(updateEntities, {
        onSettled: () => {
            queryClient.invalidateQueries(['entities']);
            queryClient.invalidateQueries(['firm']);
            queryClient.invalidateQueries(['workpapers']);
            queryClient.invalidateQueries(['groups']);
            queryClient.invalidateQueries(['group']);
        },
    });
}
